import { baseStationStates } from "@/utils/constants";
import { PaginationData } from "./RobotResponse";

export class BaseStationsResponse {
  constructor({ pages, currentPage, elements, totalElements, filters, data }) {
    this.pagination = new PaginationData(
      pages,
      currentPage,
      elements,
      totalElements,
      filters || {}
    );
    this.data =
      data && data.length > 0
        ? data.map((item) => ({
          id: item.id,
          baseStation: item.baseStation,
          imei: item.imei,
          info: item.info.nickName,
          address: item.info.address,
          accessLabels: item.accessLabel,
          robots:
            item.robot == null ||
            item.robot == undefined ||
            item.robot.length == 0
              ? "0"
              : item.robot.length,
          state: ((item.statusUpdatedAt && item.state == null)? baseStationStates.notActive : item.state),
          createdAt: item.createdAt,
          statusUpdatedAt: item.statusUpdatedAt,
          installer: item.installer == "0" ? null : item.installer,
          georefState: item.georefState ?? null,
          item: item,
        }))
        : [];
  }

}